import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';

const AdminForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [institutes, setInstitutes] = useState([]);
  const [schemes, setSchemes] = useState([]);
  const [titles, setTitles] = useState([]);
  const [adminTypes, setAdminTypes] = useState([]);
 const [salaryPositions, setSalaryPositions] = useState([]);
const [showPositionDropdown, setShowPositionDropdown] = useState(false);
  const [errorMessages, setErrorMessages] = useState({});
  const [apiErrors, setApiErrors] = useState({});
  // Add these with your other state declarations
const [balanceInfo, setBalanceInfo] = useState(null);
const [balanceLoading, setBalanceLoading] = useState(false);
const [balanceWarning, setBalanceWarning] = useState('');
  const [fileUploading, setFileUploading] = useState(false);
const [uploadedFilePath, setUploadedFilePath] = useState('');
// Add state for debit/credit
const [transactionType, setTransactionType] = useState('debit');
const [isTrainingCorpusFund, setIsTrainingCorpusFund] = useState(false);
const [formData, setFormData] = useState({
  instituteId: '',
  schemeId: '',
  year: '25s26',
  timePeriod: '2nd-quarter',
  month: '',
  asDate: '',
  asNumber: '',
  titleId: '', 
  type: '',
  position: '',
  amount: '',
  title: '',
  date: '',
  description: '',
  remarks: '' // ADD THIS LINE
});
const years = [
  { display: '26-27', withS: '26s27', withoutS: '26-27' }
];
  const currentDate = new Date();
  const currentMonthIndex = currentDate.getMonth();
// Define months for each quarter
const quarterMonths = {
  '1st-quarter': [
    { value: '04', name: 'April' },
    { value: '05', name: 'May' },
    { value: '06', name: 'June' }
  ],
  '2nd-quarter': [
    { value: '07', name: 'July' },
    { value: '08', name: 'August' },
    { value: '09', name: 'September' }
  ],
  '3rd-quarter': [
    { value: '10', name: 'October' },
    { value: '11', name: 'November' },
    { value: '12', name: 'December' }
  ],
  '4th-quarter': [
    { value: '01', name: 'January' },
    { value: '02', name: 'February' },
    { value: '03', name: 'March' }
  ]
};
  
// Define salary positions for SPRC and SPMU (only for state role)
const salaryPositionOptions = {
  'SPRC Salary': [
    'Thematic Expert (LSDG)',
    'IT and Network Communication',
    'Data Entry Operators',
    'Other Expenses'
  ],
  'SPMU Salary': [
    'State Programme Manager',
    'State Coordinator (M&E)',
    'State Coordinator (e-Gov.)',
    'Data Entry Operator'
  ]
};
  // Get user role from localStorage
  const getUserRole = () => {
    try {
      return localStorage.getItem('userRole') || '';
    } catch (error) {
      console.error('Error accessing localStorage:', error);
      return '';
    }
  };
  
  // Add this function after getUserRole
const checkBalance = async (enteredAmount) => {
  if (!enteredAmount || enteredAmount === '0') return;
  
  setBalanceLoading(true);
  setBalanceWarning('');
  
  try {
    // Use the existing API service
    const balanceData = await api.ledger.getBalance();
    
    if (balanceData && !balanceData.error && balanceData.data && balanceData.data.length > 0) {
      const currentBalance = parseFloat(balanceData.data[0].balance);
      const requestedAmount = parseFloat(enteredAmount);
      
      console.log('Balance Check:', {
        currentBalance,
        requestedAmount,
        balanceData: balanceData.data[0]
      });
      
      // Check if requested amount exceeds available balance
      if (requestedAmount > currentBalance) {
        setBalanceWarning(`Warning: Requested amount (₹${requestedAmount.toLocaleString()}) exceeds available balance (₹${currentBalance.toLocaleString()})`);
      } else if (currentBalance < 0) {
        // Also check if balance itself is negative
        setBalanceWarning(`Warning: Insufficient balance. Current balance is ₹${currentBalance.toLocaleString()}`);
      } else {
        setBalanceWarning(''); // Clear warning if amount is within available balance
      }
      
      setBalanceInfo(balanceData.data[0]);
    }
  } catch (error) {
    console.error('Error checking balance:', error);
    setBalanceWarning('Could not verify balance. Please check manually.');
  } finally {
    setBalanceLoading(false);
  }
};

const handleFileUpload = async (file) => {
  if (!file) return;
  
  setFileUploading(true);
  try {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${api.BASE_URL}/admin/upload`, {
      method: 'POST',
      headers: {
        'Authorization': localStorage.getItem('authToken')
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error('Failed to upload file');
    }
    
    const data = await response.json();
    if (data && !data.error) {
      setUploadedFilePath(data.file);
      alert('File uploaded successfully!');
    } else {
      throw new Error(data.message || 'Upload failed');
    }
  } catch (error) {
    console.error('Error uploading file:', error);
    alert(`Failed to upload file: ${error.message}`);
  } finally {
    setFileUploading(false);
  }
};

  // Set institute based on user role - modified to work with any role
const setInstituteBasedOnRole = (instituteList) => {
  try {
    const userRole = getUserRole();
    
    if (!instituteList || instituteList.length === 0) {
      console.log('Institute list is empty or undefined');
      return;
    }
    
    console.log('Available institutes:', instituteList.map(inst => ({ id: inst.id, code: inst.code, name: inst.name })));
    console.log('User role:', userRole);
    
    let selectedInstitute = null;
    
    // Use the correct role mapping from your working form
    if (userRole === 'state') {
      selectedInstitute = instituteList.find(inst => inst.code === 'SIR' || inst.name === 'SIRD');
    } else if (userRole === 'region') {
      selectedInstitute = instituteList.find(inst => inst.code === 'RIR' || inst.name === 'RIRD');
    } else if (userRole === 'district') {
      selectedInstitute = instituteList.find(inst => inst.code === 'DRC' || inst.name === 'DRCP');
    } else {
      console.log('No specific institute mapping for role:', userRole);
      // For any other role (like department), allow manual selection
      return;
    }
    
    if (selectedInstitute) {
      console.log('Selected institute:', selectedInstitute.name, 'for role:', userRole);
      setFormData(prevData => ({
        ...prevData,
        instituteId: selectedInstitute.id.toString()
      }));
    } else {
      console.log('Institute not found for role:', userRole);
      console.log('Available institute codes:', instituteList.map(inst => inst.code));
      console.log('Available institute names:', instituteList.map(inst => inst.name));
    }
  } catch (error) {
    console.error('Error in setInstituteBasedOnRole:', error);
    setApiErrors(prev => ({ ...prev, institute: error.message }));
  }
};
  // Add an admin-specific scheme endpoint to api.js
  const getAdminSchemes = async () => {
    try {
      console.log('Fetching admin schemes...');
      setApiErrors(prev => ({ ...prev, schemes: null }));
      
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      // Try using the same endpoint as infrastructure but adapt if it fails
      const response = await fetch(`${api.BASE_URL}/master/scheme/admin`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // If admin-specific endpoint fails, try the training endpoint as fallback
        console.log('Admin scheme endpoint failed, trying training endpoint as fallback');
        const fallbackResponse = await fetch(`${api.BASE_URL}/master/scheme/training`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken
          }
        });
        
        if (!fallbackResponse.ok) {
          throw new Error('Failed to fetch schemes from both endpoints');
        }
        
        const fallbackData = await fallbackResponse.json();
        console.log('Fallback scheme data:', fallbackData);
        return fallbackData;
      }
      
      const data = await response.json();
      console.log('Admin scheme data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching admin schemes:', error);
      setApiErrors(prev => ({ ...prev, schemes: error.message }));
      return { error: true, message: error.message, data: [] };
    }
  };

  // Get admin titles with their types included in the response
  const getAdminTitles = async (schemeId) => {
    try {
      console.log(`Fetching admin titles for scheme ID: ${schemeId}...`);
      setApiErrors(prev => ({ ...prev, titles: null }));
      
      const authToken = localStorage.getItem('authToken');
      if (!authToken) {
        throw new Error('No authentication token found');
      }

      // Try admin-specific endpoint first
      const response = await fetch(`${api.BASE_URL}/master/title/admin/${schemeId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authToken
        }
      });
      
      if (!response.ok) {
        // If admin-specific endpoint fails, try the training endpoint as fallback
        console.log('Admin title endpoint failed, trying training endpoint as fallback');
        const fallbackResponse = await fetch(`${api.BASE_URL}/master/title/training/${schemeId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': authToken
          }
        });
        
        if (!fallbackResponse.ok) {
          throw new Error('Failed to fetch titles from both endpoints');
        }
        
        const fallbackData = await fallbackResponse.json();
        console.log('Fallback title data:', fallbackData);
        return fallbackData;
      }
      
      const data = await response.json();
      console.log('Admin title data:', data);
      return data;
    } catch (error) {
      console.error('Error fetching admin titles:', error);
      setApiErrors(prev => ({ ...prev, titles: error.message }));
      return { error: true, message: error.message, data: [] };
    }
  };

  // Fetch institutes and schemes on component mount - removed role restriction
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        console.log('Fetching initial data...');
        
        // Get institute data
        const institutesData = await api.master.getInstitutes();
        console.log('Institutes data:', institutesData);
        
        if (institutesData && !institutesData.error) {
          setInstitutes(institutesData.data);
          setInstituteBasedOnRole(institutesData.data);
        } else {
          console.error('Error in institutes data:', institutesData);
          setApiErrors(prev => ({ ...prev, institutes: 'Failed to load institutes' }));
        }
        
        // Get admin schemes 
        const schemesData = await getAdminSchemes();
        console.log('Schemes data:', schemesData);
        
        if (schemesData && !schemesData.error) {
          setSchemes(schemesData.data || []);
        } else {
          console.error('Error in schemes data:', schemesData);
          setApiErrors(prev => ({ ...prev, schemes: 'Failed to load schemes' }));
        }
      } catch (error) {
        console.error('Error fetching initial data:', error);
        setApiErrors(prev => ({ ...prev, general: error.message }));
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, []); // Removed isAuthorized dependency

// Reset month and update year when time period changes
  useEffect(() => {
  setFormData(prevData => ({
    ...prevData,
    month: '',
    year: '26-27'
  }));
}, [formData.timePeriod]);
  // Check if selected scheme is Training Corpus Fund and user is state
  useEffect(() => {
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const userRole = getUserRole();
    
    if (selectedScheme && userRole === 'state' && selectedScheme.name === 'Training Corpus Fund') {
      setIsTrainingCorpusFund(true);
      setTransactionType('debit'); // Set default to debit
    } else {
      setIsTrainingCorpusFund(false);
      setTransactionType('debit');
    }
  }, [formData.schemeId, schemes]);

  // Fetch expenditure titles when scheme changes (only for debit flow)
  useEffect(() => {
    const fetchTitles = async () => {
      if (!formData.schemeId || (isTrainingCorpusFund && transactionType === 'credit')) return;
      
      setLoading(true);
      try {
        console.log(`Fetching titles for scheme ID: ${formData.schemeId}`);
        
        // Get admin titles for selected scheme
        const titlesData = await getAdminTitles(formData.schemeId);
        
        if (titlesData && !titlesData.error) {
          setTitles(titlesData.data || []);
          
          // Reset title selection, types, and type selection when scheme changes
          setFormData(prev => ({
            ...prev,
            titleId: '',
            type: ''
          }));
          setAdminTypes([]);
        } else {
          console.error('Error in titles data:', titlesData);
          setApiErrors(prev => ({ ...prev, titles: 'Failed to load titles' }));
        }
      } catch (error) {
        console.error('Error fetching expenditure titles:', error);
        setApiErrors(prev => ({ ...prev, titles: error.message }));
      } finally {
        setLoading(false);
      }
    };
    
    fetchTitles();
  }, [formData.schemeId, transactionType, isTrainingCorpusFund]);

  // Update admin types when titleId changes
  useEffect(() => {
    if (!formData.titleId || (isTrainingCorpusFund && transactionType === 'credit')) {
      setAdminTypes([]);
      return;
    }
    
    try {
      // Find the selected title
      const selectedTitle = titles.find(title => title.id === parseInt(formData.titleId));
      
      if (selectedTitle && selectedTitle.title_types && selectedTitle.title_types.length > 0) {
        console.log('Title types found in selected title:', selectedTitle.title_types);
        
        // Convert title_types array to format expected by the dropdown
        const formattedTypes = selectedTitle.title_types.map((type, index) => ({
          id: index + 1,
          name: type
        }));
        
        setAdminTypes(formattedTypes);
        
        // Reset type selection
        setFormData(prevData => ({
          ...prevData,
          type: ''
        }));
      } else {
        console.log('No title types found for selected title');
        
        // If no title_types are provided, use default types
        setAdminTypes([
          { id: 1, name: "Fixed" },
          { id: 2, name: "Variable" }
        ]);
      }
    } catch (error) {
      console.error('Error updating admin types:', error);
      setApiErrors(prev => ({ ...prev, types: error.message }));
      
      // Set default types on error
      setAdminTypes([
        { id: 1, name: "Fixed" },
        { id: 2, name: "Variable" }
      ]);
    }
  }, [formData.titleId, titles, transactionType, isTrainingCorpusFund]);

  // Handle input changes
const handleChange = (e) => {
  try {
    const { name, value } = e.target;
    
    setErrorMessages(prev => ({
      ...prev,
      [name]: undefined
    }));
    
    if (name === 'titleId' && value) {
      const selectedTitle = titles.find(t => t.id === parseInt(value));
      if (selectedTitle) {
        console.log('Selected title:', selectedTitle.name);
        setFormData({
          ...formData,
          [name]: value,
          title: selectedTitle.name
        });
        return;
      }
    }
// ADD THIS NEW SECTION FOR TYPE HANDLING (ONLY FOR STATE ROLE)
if (name === 'type') {
  const userRole = getUserRole();
  
  // Check if user is state role AND selected type is SPRC/SPMU salary
  if (userRole === 'state' && (value === 'SPRC Salary' || value === 'SPMU Salary')) {
    setShowPositionDropdown(true);
    setSalaryPositions(salaryPositionOptions[value] || []);
    setFormData({ 
      ...formData, 
      [name]: value,
      position: '' // Reset position when type changes
    });
  } else {
    setShowPositionDropdown(false);
    setSalaryPositions([]);
    setFormData({ 
      ...formData, 
      [name]: value,
      position: '' // Clear position if not salary type or not state role
    });
  }
  return;
}
    if (name === 'amount') {
      const numericValue = value.replace(/\D/g, '');
      setFormData({ ...formData, [name]: numericValue });
      
      if (numericValue && numericValue !== '0' && (!isTrainingCorpusFund || transactionType === 'debit')) {
        checkBalance(numericValue);
      }
      
      return;
    }
    
    setFormData({ ...formData, [name]: value });
  } catch (error) {
    console.error('Error in handleChange:', error);
  }
};

const handleTransactionTypeChange = (type) => {
  setTransactionType(type);
  
  // Clear form data when switching between debit and credit
  setFormData(prev => ({
    ...prev,
    titleId: '',
    type: '',
    asDate: '',
    asNumber: '',
    date: '',
    description: '',
    remarks: '' // ADD THIS LINE
  }));
  
  // Clear any balance warnings for credit transactions
  if (type === 'credit') {
    setBalanceWarning('');
  }
};
const validateForm = () => {
  const errors = {};
  
  const commonFields = [
    { key: 'schemeId', label: 'Scheme' },
    { key: 'amount', label: 'Amount' }
  ];
  
  let additionalFields = [];
  
  if (isTrainingCorpusFund && transactionType === 'credit') {
    additionalFields = [
      { key: 'date', label: 'Date' },
      { key: 'description', label: 'Description' }
    ];
  } else {
    additionalFields = [
      { key: 'year', label: 'Year' },
      { key: 'month', label: 'Month' },
      { key: 'asDate', label: 'A.S Date' },
      { key: 'asNumber', label: 'A.S Number' },
      { key: 'titleId', label: 'Title of Expenditure' },
      { key: 'type', label: 'Type' }
    ];
    
    // ADD THIS: Validate position ONLY if state role AND SPRC/SPMU salary is selected
    const userRole = getUserRole();
    if (userRole === 'state' && showPositionDropdown) {
      additionalFields.push({ key: 'position', label: 'Position' });
    }
  }
  
  const requiredFields = [...commonFields, ...additionalFields];
  
  requiredFields.forEach(field => {
    if (!formData[field.key]) {
      errors[field.key] = `${field.label} is required`;
    }
  });
  
  if (formData.amount && isNaN(Number(formData.amount))) {
    errors.amount = 'Amount must be a number';
  }
  
  setErrorMessages(errors);
  return Object.keys(errors).length === 0;
};

  // Handle form submission
const handleSubmit = async (e) => {
  e.preventDefault();
  
  // Check if there's a balance warning and block proceeding (only for debit transactions)
  if (balanceWarning && (!isTrainingCorpusFund || transactionType === 'debit')) {
    alert('Cannot proceed: ' + balanceWarning);
    return;
  }
  
  if (!validateForm()) {
    console.log('Form validation failed');
    return;
  }
  
  setLoading(true);
  try {
    console.log('Submitting admin form data...');
    
    // Get selected institute, scheme and title
    const selectedInstitute = institutes.find(institute => institute.id === parseInt(formData.instituteId));
    const selectedScheme = schemes.find(scheme => scheme.id === parseInt(formData.schemeId));
    const selectedTitle = titles.find(title => title.id === parseInt(formData.titleId));
    
    if (!selectedInstitute) {
      throw new Error('Selected institute not found');
    }
    
    // Get center_name from localStorage
    const center_name = localStorage.getItem('name') || '';
    console.log('Center name:', center_name);

    // Format data for API based on transaction type
    let finalData;
    
if (isTrainingCorpusFund && transactionType === 'credit') {
  // Credit flow - simplified data
  finalData = {
    institute: selectedInstitute ? selectedInstitute.code : '',
    scheme: selectedScheme ? selectedScheme.code : '',
    scheme_name: selectedScheme ? selectedScheme.name : '',
    center_name: center_name,
    year: formData.year,
    month: formData.month,
        date: formData.date,
        description: formData.description,
        amount: formData.amount,
        type: "Admin",
        scheme_type: "Credit"
      };
} else {
  // Debit flow - existing data structure
  finalData = {
    institute: selectedInstitute ? selectedInstitute.code : '',
    scheme: selectedScheme ? selectedScheme.code : '',
    scheme_name: selectedScheme ? selectedScheme.name : '',
    center_name: center_name,
    stitle: selectedTitle ? selectedTitle.code : '',
    title: selectedTitle ? selectedTitle.name : '',
    year: formData.timePeriod === '2nd-quarter' ? formData.year.replace('-', 's') : formData.year,
    month: formData.month,
    asDate: formData.asDate,
    asNumber: formData.asNumber,
    asFile: uploadedFilePath,
    type: "Admin",
    scheme_type: isTrainingCorpusFund ? transactionType : formData.type,
    position: showPositionDropdown ? formData.position : '',
    amount: formData.amount,
    remarks: formData.remarks || '' // ADD THIS LINE
  };
} 
    console.log('Final data being submitted:', finalData);
    
    // Using the API endpoint for admin
    const authToken = localStorage.getItem('authToken');
    if (!authToken) {
      throw new Error('No authentication token found');
    }
    
    const response = await fetch(`${api.BASE_URL}/project/admin`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken
      },
      body: JSON.stringify(finalData)
    });
    
    const responseData = await response.json();
    console.log('API response:', responseData);
    
    if (!response.ok) {
      throw new Error(responseData.message || 'Failed to submit admin data');
    }
    
    if (responseData && !responseData.error) {
      alert('Admin expenditure data submitted successfully!');
      navigate('/dashboard');
    } else {
      throw new Error(responseData.message || 'Error submitting data');
    }
  } catch (error) {
    console.error('Error submitting admin data:', error);
    alert(`Failed to submit: ${error.message}`);
    setApiErrors(prev => ({ ...prev, submit: error.message }));
  } finally {
    setLoading(false);
  }
};

  // Get the name of the selected institute
  const getSelectedInstituteName = () => {
    if (formData.instituteId && institutes.length > 0) {
      const selectedInstitute = institutes.find(inst => inst.id === parseInt(formData.instituteId));
      return selectedInstitute ? selectedInstitute.name : '';
    }
    return '';
  };

  return (
    <div className="bg-gradient-to-b from-blue-50 to-white min-h-screen py-8 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-4xl mx-auto border border-gray-100">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-8 border-b pb-6">
          <div>
            <h2 className="text-2xl font-bold text-blue-800 mb-2">Admin Expenses</h2>
            <p className="text-gray-600">Submit admin expenditure details</p>
          </div>
        </div>
        
        {/* API Errors Alert */}
        {Object.values(apiErrors).some(error => error) && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-lg">
            <h3 className="text-red-700 font-medium mb-2">There were issues loading some data:</h3>
            <ul className="list-disc ml-5 text-sm text-red-600">
              {Object.entries(apiErrors).map(([key, error]) => (
                error && <li key={key}>{key}: {error}</li>
              ))}
            </ul>
            <p className="mt-2 text-sm text-gray-700">
              Some options may be unavailable. Please try refreshing the page or contact support if the problem persists.
            </p>
          </div>
        )}
        
        {loading && (
          <div className="text-center mb-6 p-4 bg-blue-50 rounded-lg">
            <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-b-2 border-blue-600 mx-auto"></div>
            <p className="mt-3 text-blue-700 font-medium">Loading data, please wait...</p>
          </div>
        )}
        
        <form className="space-y-8" onSubmit={handleSubmit}>
          {/* Basic Information */}
          <div>
            <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Basic Information</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Display selected institute as text */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Institute
                </label>
                <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
                  {getSelectedInstituteName() || 'Loading...'}
                </div>
                {errorMessages.instituteId && (
                  <p className="mt-1 text-sm text-red-600">{errorMessages.instituteId}</p>
                )}
              </div>
              
              {/* Scheme Selection */}
              <div className="relative">
                <label htmlFor="schemeId" className="block text-sm font-medium text-gray-700 mb-1">
                  Scheme <span className="text-red-500">*</span>
                </label>
                <select
                  id="schemeId"
                  name="schemeId"
                  required
                  value={formData.schemeId}
                  onChange={handleChange}
                  disabled={loading || schemes.length === 0}
                  className={`block w-full rounded-md border ${errorMessages.schemeId ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none ${(loading || schemes.length === 0) ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                >
                  <option value="">Select Scheme</option>
                  {schemes.map(scheme => (
                    <option key={scheme.id} value={scheme.id}>
                      {scheme.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                  <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </div>
                {errorMessages.schemeId && (
                  <p className="mt-1 text-sm text-red-600">{errorMessages.schemeId}</p>
                )}
              </div>
            </div>
          </div>
          
          {/* Transaction Type Selection for Training Corpus Fund */}
          {isTrainingCorpusFund && (
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Transaction Type</h3>
              <div className="flex space-x-6">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="transactionType"
                    value="debit"
                    checked={transactionType === 'debit'}
                    onChange={() => handleTransactionTypeChange('debit')}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span className="ml-2 text-sm font-medium text-gray-700">Debit</span>
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="transactionType"
                    value="credit"
                    checked={transactionType === 'credit'}
                    onChange={() => handleTransactionTypeChange('credit')}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300"
                  />
                  <span className="ml-2 text-sm font-medium text-gray-700">Credit</span>
                </label>
              </div>
            </div>
          )}

          {/* Credit Flow Fields */}
          {isTrainingCorpusFund && transactionType === 'credit' && (
            <div>
              <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Credit Details</h3>
              <div className="grid grid-cols-1 gap-6">
                {/* Date */}
                <div>
                  <label htmlFor="date" className="block text-sm font-medium text-gray-700 mb-1">
                    Date <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    id="date"
                    name="date"
                    required
                    value={formData.date}
                    onChange={handleChange}
                    className={`block w-full rounded-md border ${errorMessages.date ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                  />
                  {errorMessages.date && (
                    <p className="mt-1 text-sm text-red-600">{errorMessages.date}</p>
                  )}
                </div>
                
                {/* Description */}
                <div>
                  <label htmlFor="description" className="block text-sm font-medium text-gray-700 mb-1">
                    Description <span className="text-red-500">*</span>
                  </label>
                  <textarea
                    id="description"
                    name="description"
                    required
                    value={formData.description}
                    onChange={handleChange}
                    rows="3"
                    placeholder="Enter description"
                    className={`block w-full rounded-md border ${errorMessages.description ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                  />
                  {errorMessages.description && (
                    <p className="mt-1 text-sm text-red-600">{errorMessages.description}</p>
                  )}
                </div>
                
                {/* Amount */}
                <div>
                  <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
                    Amount <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="amount"
                    name="amount"
                    required
                    value={formData.amount}
                    onChange={handleChange}
                    placeholder="Enter amount"
                    className={`block w-full rounded-md border ${errorMessages.amount ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                  />
                  {errorMessages.amount && (
                    <p className="mt-1 text-sm text-red-600">{errorMessages.amount}</p>
                  )}
                </div>
              </div>
            </div>
          )}

          {/* Debit Flow Fields */}
          {(!isTrainingCorpusFund || transactionType === 'debit') && (
            <>
              {/* Administrative Details */}
              <div>
                <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Administrative Details</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {/* A.S Date */}
                  <div>
                    <label htmlFor="asDate" className="block text-sm font-medium text-gray-700 mb-1">
                      A.S Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      id="asDate"
                      name="asDate"
                      required
                      value={formData.asDate}
                      onChange={handleChange}
                      className={`block w-full rounded-md border ${errorMessages.asDate ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                    />
                    {errorMessages.asDate && (
                      <p className="mt-1 text-sm text-red-600">{errorMessages.asDate}</p>
                    )}
                  </div>
                  
                  {/* A.S Number */}
                  <div>
                    <label htmlFor="asNumber" className="block text-sm font-medium text-gray-700 mb-1">
                      A.S Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="asNumber"
                      name="asNumber"
                      required
                      value={formData.asNumber}
                      onChange={handleChange}
                      placeholder="Enter A.S number"
                      className={`block w-full rounded-md border ${errorMessages.asNumber ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                    />
                    {errorMessages.asNumber && (
                      <p className="mt-1 text-sm text-red-600">{errorMessages.asNumber}</p>
                    )}
                    
                    {/* File Upload for A.S Number */}
                    <div className="mt-2">
                      <label htmlFor="asFile" className="block text-sm font-medium text-gray-700 mb-1">
                        Upload A.S File
                      </label>
                      <input
                        type="file"
                        id="asFile"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={(e) => {
                          const file = e.target.files[0];
                          if (file) {
                            handleFileUpload(file);
                          }
                        }}
                        disabled={fileUploading}
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-medium file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100 disabled:opacity-50"
                      />
                      
                      {fileUploading && (
                        <div className="mt-2 flex items-center text-sm text-blue-600">
                          <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          Uploading file...
                        </div>
                      )}
                      
                      {uploadedFilePath && (
                        <div className="mt-2 p-2 bg-green-50 border border-green-200 rounded-md">
                          <div className="flex items-center text-sm text-green-700">
                            <svg className="h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            File uploaded successfully: {uploadedFilePath.split('/').pop()}
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
      {/* Time Period */}
<div>
  <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Time Period</h3>
  <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
{/* Time Period Selection - FIRST */}
<div className="relative">
  <label htmlFor="timePeriod" className="block text-sm font-medium text-gray-700 mb-1">
    Time Period <span className="text-red-500">*</span>
  </label>
  <select
    id="timePeriod"
    name="timePeriod"
    required
    value={formData.timePeriod}
    onChange={handleChange}
    className="block w-full rounded-md border border-gray-300 shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none"
  >
    <option value="1st-quarter">1st Quarter</option>
    <option value="2nd-quarter">2nd Quarter</option>
    <option value="3rd-quarter">3rd Quarter</option>
    <option value="4th-quarter">4th Quarter</option>
  </select>
  <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
    <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
      <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
    </svg>
  </div>
</div>

    {/* Year Display - SECOND (display only, not selectable) */}
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Year <span className="text-red-500">*</span>
      </label>
      <div className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 bg-gray-50">
        {formData.year}
      </div>
    </div>

    {/* Month Selection - THIRD */}
    <div className="relative">
      <label htmlFor="month" className="block text-sm font-medium text-gray-700 mb-1">
        Month <span className="text-red-500">*</span>
      </label>
      <select
        id="month"
        name="month"
        required
        value={formData.month}
        onChange={handleChange}
        className={`block w-full rounded-md border ${errorMessages.month ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none`}
      >
        <option value="">Select Month</option>
        {quarterMonths[formData.timePeriod]?.map((month) => (
          <option key={month.value} value={month.value}>
            {month.name}
          </option>
        ))}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </div>
      {errorMessages.month && (
        <p className="mt-1 text-sm text-red-600">{errorMessages.month}</p>
      )}
    </div>
    
  </div>
</div>
              
              {/* Expenditure Details */}
              <div>
                <h3 className="text-lg font-semibold text-gray-700 mb-4 border-b pb-2">Admin Details</h3>
                <div className="grid grid-cols-1 gap-6">
                  {/* Title of Expenditure Selection - Based on scheme */}
                  <div className="relative">
                    <label htmlFor="titleId" className="block text-sm font-medium text-gray-700 mb-1">
                      Title of Expenditure <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="titleId"
                      name="titleId"
                      required
                      value={formData.titleId}
                      onChange={handleChange}
                      disabled={!formData.schemeId || loading || titles.length === 0}
                      className={`block w-full rounded-md border ${errorMessages.titleId ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none ${!formData.schemeId || loading || titles.length === 0 ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                    >
                      <option value="">Select Title of Expenditure</option>
                      {titles.map(title => (
                        <option key={title.id} value={title.id}>
                          {title.name}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                      <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                    {errorMessages.titleId && (
                      <p className="mt-1 text-sm text-red-600">{errorMessages.titleId}</p>
                    )}
                  </div>
                  
                  {/* Type Selection - Based on title */}
                  <div className="relative">
                    <label htmlFor="type" className="block text-sm font-medium text-gray-700 mb-1">
                      Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      id="type"
                      name="type"
                      required
                      value={formData.type}
                      onChange={handleChange}
                      disabled={!formData.titleId || loading || adminTypes.length === 0}
                      className={`block w-full rounded-md border ${errorMessages.type ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none ${!formData.titleId || loading || adminTypes.length === 0 ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                    >
                      <option value="">Select Type</option>
                      {adminTypes.map(type => (
                        <option key={type.id} value={type.name}>
                          {type.name}
                        </option>
                      ))}
                    </select>
                    <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                      <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                        <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                    {errorMessages.type && (
                      <p className="mt-1 text-sm text-red-600">{errorMessages.type}</p>
                    )}
                  </div>
                   {/* ADD THIS ENTIRE SECTION - Position Selection for SPRC/SPMU salary */}
                  {showPositionDropdown && (
                    <div className="relative">
                      <label htmlFor="position" className="block text-sm font-medium text-gray-700 mb-1">
                        Position <span className="text-red-500">*</span>
                      </label>
                      <select
                        id="position"
                        name="position"
                        required
                        value={formData.position}
                        onChange={handleChange}
                        className={`block w-full rounded-md border ${errorMessages.position ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 pl-3 pr-10 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition appearance-none`}
                      >
                        <option value="">Select Position</option>
                        {salaryPositions.map((position, index) => (
                          <option key={index} value={position}>
                            {position}
                          </option>
                        ))}
                      </select>
                      <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 pt-6">
                        <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                          <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </div>
                      {errorMessages.position && (
                        <p className="mt-1 text-sm text-red-600">{errorMessages.position}</p>
                      )}
                    </div>
                  )}
                  {/* Amount */}
                  <div>
                    <label htmlFor="amount" className="block text-sm font-medium text-gray-700 mb-1">
                      Amount <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      id="amount"
                      name="amount"
                      required
                      value={formData.amount}
                      onChange={handleChange}
                      placeholder="Enter amount"
                      className={`block w-full rounded-md border ${errorMessages.amount ? 'border-red-300' : 'border-gray-300'} shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition`}
                    />
                     {/* ADD THIS - Remarks field for state role only */}
                  {getUserRole() === 'state' && (
                    <div>
                      <label htmlFor="remarks" className="block text-sm font-medium text-gray-700 mb-1">
                        Remarks
                      </label>
                      <textarea
                        id="remarks"
                        name="remarks"
                        value={formData.remarks || ''}
                        onChange={handleChange}
                        rows="3"
                        placeholder="Enter any remarks or comments"
                        className="block w-full rounded-md border border-gray-300 shadow-sm py-2 px-3 text-gray-700 focus:border-blue-600 focus:ring focus:ring-blue-200 focus:ring-opacity-50 transition"
                      />
                      {errorMessages.remarks && (
                        <p className="mt-1 text-sm text-red-600">{errorMessages.remarks}</p>
                      )}
                    </div>
                  )}
                    {/* Add Balance Loading and Warning Display */}
                    {balanceLoading && (
                      <div className="mt-2 flex items-center text-sm text-blue-600">
                        <svg className="animate-spin h-4 w-4 mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        Checking balance...
                      </div>
                    )}

                    {balanceWarning && (
                      <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
                        <div className="flex">
                          <svg className="h-5 w-5 text-red-400 mr-2 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                          </svg>
                          <div className="text-sm text-red-700">
                            {balanceWarning}
                          </div>
                        </div>
                      </div>
                    )}
                    
                    {errorMessages.amount && (
                      <p className="mt-1 text-sm text-red-600">{errorMessages.amount}</p>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
          
          {/* Form action buttons */}
          <div className="pt-6 border-t border-gray-200">
            <div className="flex flex-col-reverse sm:flex-row justify-end space-y-4 space-y-reverse sm:space-y-0 sm:space-x-4">
              <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="px-5 py-2.5 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loading || (balanceWarning && (!isTrainingCorpusFund || transactionType === 'debit'))} // Disable if loading OR balance warning for debit only
                className={`px-5 py-2.5 border border-transparent rounded-md shadow-sm text-sm font-medium text-white ${
                  (balanceWarning && (!isTrainingCorpusFund || transactionType === 'debit'))
                    ? 'bg-gray-400 cursor-not-allowed' 
                    : 'bg-blue-600 hover:bg-blue-700'
                } focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center`}
              >
                {loading ? (
                  <>
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    Submitting...
                  </>
                ) : (balanceWarning && (!isTrainingCorpusFund || transactionType === 'debit')) ? (
                  'Cannot Submit - Balance Issue'
                ) : (
                  'Submit'
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminForm;